export const environment = {
  production: false,
  apiUrl: 'https://dev-www.wd-im.de/api/mini',
};
